
import { Component, Vue } from 'vue-property-decorator';
import Alert from '~/components/Alerts/Alert.vue';
import BankDetails from '@/components/BankAccountSetup/BankDetails.vue';
import CustomButton from '~/components/Buttons/CustomButton.vue';
import DepositsTable from '@/components/common/DepositsTable.vue';
import ResponsiveContainer from '@/components/Layout/ResponsiveContainer.vue';
import SetupSuccessScreen from '@/components/BankAccountSetup/SetupSuccessScreen.vue';
import VerifyDepositsAmount from '@/components/BankAccountSetup/VerifyDepositsAmount.vue';
import { PaymentProviderBankDetails, VerificationStatuses } from '@/interfaces/bank-account';
import { reinitiateMicroDeposits } from '@/api/account';

@Component({
  components: {
    Alert,
    BankDetails,
    CustomButton,
    DepositsTable,
    ResponsiveContainer,
    SetupSuccessScreen,
    VerifyDepositsAmount
  }
})
export default class BankAccountSetup extends Vue {
  step = 0;

  accountLocked = false;

  verificationFailed = false;

  hideBankAccountInputs = false;

  exceededLimit = false;

  loading = false;

  showInterstitial = false;

  get supportEmail() {
    return this.$store.getters['Config/getBrandSupportEmail'];
  }

  get supportPhone() {
    return this.$store.getters['Config/getBrandSupportPhone'];
  }

  get bankDetails(): PaymentProviderBankDetails {
    return this.$store.getters['Account/getBankDetails'];
  }

  async created() {
    switch (this.bankDetails.bank_status) {
      case VerificationStatuses.NEW:
        this.step = 1;
        this.hideBankAccountInputs = true;
        break;

      case VerificationStatuses.PENDING:
        this.step = 2;
        break;

      case VerificationStatuses.VERIFICATION_FAILED:
        this.verificationFailed = true;
        this.step = 1;
        break;

      case VerificationStatuses.ERRORED:
        this.accountLocked = true;
        break;

      case VerificationStatuses.VERIFIED:
        this.$router.push({ name: 'home' });
        break;

      default:
        this.step = 1;
        break;
    }
  }

  showInterstitialScreen() {
    this.verificationFailed = false;
    this.showInterstitial = true;
  }

  setExceededLimit() {
    this.exceededLimit = true;
  }

  async sendDeposits() {
    this.loading = true;
    try {
      await reinitiateMicroDeposits();
      this.showInterstitialScreen();
    } catch {
      this.$router.push({ name: 'error' });
    } finally {
      this.loading = false;
    }
  }
}
